export default __webpack_public_path__ + "2b399de77223cf21bc9f5304d0a68f8a.svg";